import { render, staticRenderFns } from "./NotAvailable.vue?vue&type=template&id=6a472b1c"
import script from "./NotAvailable.vue?vue&type=script&lang=js"
export * from "./NotAvailable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports